// pages/Dashboard.jsx
import AboutUs from "../../components/home/aboutPageComponents/AboutPage";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <AboutUs />
    </HomeLayout>
  );
}
